// @context TGW-2195 「公開まであと N 項目」の単体テスト（詳細設計 §7.1）。
import { countRequiredRemaining } from './required_remaining';

const plan = (attrs = {}) => ({ id: 1, is_deleted: false, ...attrs });

describe('countRequiredRemaining', () => {
  it('全部空なら3（日時・場所・チケット）', () => {
    expect(countRequiredRemaining({ event: {}, eventsPlans: [] })).toBe(3);
  });

  it('日時だけ入っていれば2', () => {
    expect(
      countRequiredRemaining({
        event: {
          event_date: '2026/10/01 19:00',
          event_end_datetime: '2026/10/01 21:00',
        },
        eventsPlans: [],
      })
    ).toBe(2);
  });

  it('開始だけで終了が無ければ日時は未充足', () => {
    expect(
      countRequiredRemaining({
        event: { event_date: '2026/10/01 19:00' },
        eventsPlans: [],
      })
    ).toBe(3);
  });

  it('オンライン開催で接続先URLが空なら場所の代わりに1件残る', () => {
    expect(
      countRequiredRemaining({
        event: {
          is_online: true,
          online_url: '',
          event_date: '2026/10/01 19:00',
          event_end_datetime: '2026/10/01 21:00',
        },
        eventsPlans: [plan()],
      })
    ).toBe(1);
  });

  it('オンライン開催で接続先URLがあれば場所の項目は充足扱い', () => {
    expect(
      countRequiredRemaining({
        event: {
          is_online: true,
          online_url: 'https://zoom.us/j/123',
          event_date: '2026/10/01 19:00',
          event_end_datetime: '2026/10/01 21:00',
        },
        eventsPlans: [plan()],
      })
    ).toBe(0);
  });

  it('オンライン開催でURL形式が不正なら1件残る', () => {
    expect(
      countRequiredRemaining({
        event: {
          is_online: true,
          online_url: 'zoom.us/j/123',
          event_date: '2026/10/01 19:00',
          event_end_datetime: '2026/10/01 21:00',
        },
        eventsPlans: [plan()],
      })
    ).toBe(1);
  });

  it('削除済みチケットしか無ければチケットは未充足', () => {
    expect(
      countRequiredRemaining({
        event: {
          event_date: '2026/10/01 19:00',
          event_end_datetime: '2026/10/01 21:00',
          place: '渋谷',
        },
        eventsPlans: [plan({ is_deleted: true })],
      })
    ).toBe(1);
  });

  it('全部入っていれば0', () => {
    expect(
      countRequiredRemaining({
        event: {
          event_date: '2026/10/01 19:00',
          event_end_datetime: '2026/10/01 21:00',
          place: '渋谷',
        },
        eventsPlans: [plan(), plan({ id: 2, is_deleted: true })],
      })
    ).toBe(0);
  });

  it('eventsPlans が未定義でも落ちない', () => {
    expect(countRequiredRemaining({ event: {} })).toBe(3);
  });
});
